import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { TABS } from "../../constants/MainTabs";
import DarkModeToggle from "../generic/DarkModeToggle";

interface DesktopNavigationProps {
    handleLogout: () => void;
    showLogin: () => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
                                                                 handleLogout,
                                                                 showLogin,
                                                             }) => {
    const { isLoggedIn } = useContext(UserContext);

    return (
        <nav
            className="
        hidden lg:flex
        flex-col
        h-screen
        bg-gray-100 dark:bg-gray-900
        w-72
        p-6
        shadow-lg
        fixed
        left-0 top-0
        z-50
      "
        >
            {/* TOP: Branding */}
            <div className="mb-8">
                <Link
                    to="/"
                    className="
            text-3xl font-bold px-2
            text-gray-800 dark:text-gray-200
            hover:text-blue-500 dark:hover:text-blue-300
            transition-colors duration-200
          "
                >
                    Material Logs
                </Link>
            </div>

            <hr className={"border-gray-300 dark:border-gray-700 pb-6"}/>

            {/* MIDDLE: Main Nav Links */}
            <div className="flex-grow flex flex-col space-y-4">
                {isLoggedIn ? (
                    <>
                        {TABS.map((tab) => (
                            <Link key={tab.endpoint} to={`/${tab.endpoint}`} className="nav-link">
                                {tab.label}
                            </Link>
                        ))}
                    </>
                ) : (
                    <Link to="#" onClick={showLogin} className="nav-link">
                        Login
                    </Link>
                )}
            </div>

            <hr className={"border-gray-300 dark:border-gray-700"}/>
            {/* BOTTOM: Dark Mode Toggle & Logout, side by side */}
            <div className="mt-auto pt-4 flex items-center space-x-4">
                {isLoggedIn && (
                    <Link to="#" onClick={handleLogout} className="nav-link">
                        Logout
                    </Link>
                )}
                <DarkModeToggle/>
            </div>
        </nav>
    );
};

export default DesktopNavigation;
